import { type UploadFile } from 'antd';
import { boolean, mixed, object, string } from 'yup';
import type { UploadFileOutputDto } from '../file/model';
import type { VideoModelCode } from '../video-model/model-spec';
import {
  durationSchema,
  multiPromptSchema,
  simplePromptSchema,
} from '../video/schema';

export const frameImageSchema = object({
  product_name: string().nullable().required('请输入产品名'),
  model: string<VideoModelCode>().nullable().required('请选择生成平台'),
  aspect_ratio: string().nullable().required('请选择宽高比'),
  first_frame: mixed<UploadFile<UploadFileOutputDto>>()
    .nullable()
    .required('请选择首帧图片'),
  end_frame: mixed<UploadFile<UploadFileOutputDto>>().nullable(),
  duration: durationSchema,
  prompt: simplePromptSchema,
  multi_prompt: multiPromptSchema,
  extra_prompt: string().nullable(),
  generate_audio: boolean().default(true),
});
